// Development Environment
const DEV_CONFIG = {
  BACKEND_URL: "api.shahi.hexanet.in/",
  HOST: "shahi.hexanet.in",
};

// Production Environment
const PROD_CONFIG = {
  BACKEND_URL: process.env.VUE_APP_BACKEND_URL || "",
  HOST: process.env.VUE_APP_FRONTEND_URL || "",
};

const CONFIGS = {
  dev: DEV_CONFIG,
  prod: PROD_CONFIG,
};

export const CONFIG = CONFIGS.prod;

export default {
  CONFIG: CONFIG,
};
